import {
    BaseLayer,
    BaseLayerFactory_27700,
    BaseLayerType
} from "esdm-map";
import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import TileWMS from 'ol/source/TileWMS';
import TileGrid from "ol/tilegrid/TileGrid";
import XYZ from 'ol/source/XYZ';

export const YorkBaseLayerTypes = {
    ...BaseLayerType,
    YorkOS: 999,
    OS_1852_Historic: 1000,
    YorkAerials: 1001,
    Lidar: 1002
};

export class YorkBaseLayerFactory_27700 extends BaseLayerFactory_27700{

    private resolutions = [
        105.83354500042334,
        52.91677250021167,
        26.458386250105836,
        10.583354500042335,
        5.291677250021167,
        3.9687579375158752,
        2.6458386250105836,
        1.8520870375074086,
        1.0583354500042335,
        0.6614596562526459,
        0.33072982812632296,
        0.13229193125052918
    ];

    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string, esdmOsmApiKey: string): IBaseLayer {      
        switch (baseLayerType) {
            case YorkBaseLayerTypes.YorkOS:
                return this.GetYorkOS();

            case YorkBaseLayerTypes.OS_1852_Historic:
                return this.GetYorkOS_1852_Historic();

            case YorkBaseLayerTypes.YorkAerials:
                return this.GetYorkAerials();

            case YorkBaseLayerTypes.Lidar:
                return this.GetLidar();

            default:
                return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmOsmApiKey);
        }        
    }    

    private GetYorkOS(): IBaseLayer {       
       
        return this.GetEsriLayer("YorkOS", "Ordnance Survey", "cache_colour", "<div>© Crown copyright and database rights 2023 Ordnance Survey: AC0000822532</div>");
    }

    private GetYorkOS_1852_Historic(): IBaseLayer {         
        return this.GetEsriLayer("YorkOS_1852_Historic", "Ordnance Survey 1852", "Corporate_Cache1852", "<div>© Crown copyright and database rights 2023 Ordnance Survey: AC0000822532</div>");
    }


    private GetYorkAerials(): IBaseLayer {        
        return this.GetEsriLayer("YorkAerials", "Aerial photos", "cache_aerial2017", null);
    }

    private GetEsriLayer(ref: string, name: string, cacheName: string, attribution: string) {
        var tilegrid = new TileGrid({
            resolutions: this.resolutions,
            origin: [-5220400.0, 4470200.0]
        })
        var lyr = new TileLayer({
            source: new XYZ({
                url: `https://maps.york.gov.uk/arcgis/rest/services/Basemaps/${cacheName}/MapServer/tile/{z}/{y}/{x}`,
                projection: "EPSG:27700",
                tileGrid: tilegrid,
                attributions: attribution
            })            
        });
        return new BaseLayer(ref, name, lyr);
    }

    private GetLidar(): IBaseLayer {
        let lyr = new TileLayer({
            visible: false,
            source: new TileWMS({
                //url: "https://environment.data.gov.uk/spatialdata/lidar-composite-digital-surface-model-last-return-dsm-1m-2022/wms",
                url: "https://environment.data.gov.uk/spatialdata/lidar-composite-digital-terrain-model-dtm-1m/wms",
                params: {
                    LAYERS: 'Lidar_Composite_Hillshade_DTM_1m',
                    TILED: 'true',
                    FORMAT: 'image/png',
                    SRS: 'EPSG:27700'
                },
                projection: "EPSG:27700",
                attributions: ["<div>© Environment Agency copyright and/or database right 2015 and 2022. All rights reserved.</div>"]
            })
        });
        return new BaseLayer("Lidar", "Lidar Composite Hillshade DTM 1m", lyr);
    }
}